import React, { useEffect, useLayoutEffect, useState } from "react";
import axiosInstance from '../axiosInstance';
import { useParams, useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL_All } from "../api";
import { Card, Form } from "react-bootstrap";
import { setFilters } from "../redux/filterReducer";
import { useDispatch, useSelector } from "react-redux";
import { FaPlus, FaTimes, FaCheckCircle, FaTrash } from 'react-icons/fa';
import { FiArrowLeft } from "react-icons/fi";
import Swal from "sweetalert2";
import * as general from '../libs/general';
import { fetchCustomerMenuPermissions } from "../libs/customerCreatePermission";
import { CUSTOMER_LIST_PATH, isNewCustomerRouteId } from "../routes/customerRoutes";
import AdLayout from '../components/AdLayout';
import CustomerChildUsersPanel from '../components/users/CustomerChildUsersPanel';
import "../css/DepartmentDetail.css";
import { ClockIcon, MedalIcon } from '../components/tickets/Tickets';

const API_URL = `${API_URL_All}/api/users`; // API URL khách hàng

const CUSTOMER_PRICE_LINES = [
  { lineId: 1, weightTitle: "Line thương mại điện tử: Hàng nặng", sizeTitle: "Line thương mại điện tử: Hàng cồng kềnh", weightKey: "ecommerceWeightFees", sizeKey: "ecommerceSizeFees", vat: false },
  { lineId: 4, weightTitle: "Line Thường: Hàng nặng", sizeTitle: "Line Thường: Hàng cồng kềnh", weightKey: "economyWeightFees", sizeKey: "economySizeFees", vat: false },
  { lineId: 11, weightTitle: "Line XT: Hàng nặng", sizeTitle: "Line XT: Hàng cồng kềnh", weightKey: "handheldWeightFees", sizeKey: "handheldSizeFees", vat: false },
  { lineId: 12, weightTitle: "Line chính ngạch: Hàng nặng", sizeTitle: "Line chính ngạch: Hàng cồng kềnh", weightKey: "vatWeightFees", sizeKey: "vatSizeFees", vat: true },
];

/** Bảng giá (chỉ xem) của khách: tách khung giá theo bảng giá phổ thông và từng bảng giá phụ của level. */
const CustomerLevelPriceTables = ({ level, lineIds }) => {
  const renderFeeTable = (fees, type, vat, priceTypeId) => {
    const filteredFees = (fees ?? []).filter((item) => (priceTypeId ? item.priceTypeId === priceTypeId : !item.priceTypeId));
    return (
      <table className="table table-striped table-hover table-bordered">
        <thead className="table-primary">
          <tr>
            <th width="50px">STT</th>
            <th><span data-note={type}>Khoảng</span></th>
            <th><span data-note="vnđ">Giá</span></th>
            {vat && <th><span data-note="vnđ">Phí đầu mục</span></th>}
            {vat && <th><span data-note="%">Phí ủy thác</span></th>}
          </tr>
        </thead>
        <tbody>
          {filteredFees.map((item, index) => (
            <tr key={item.id}>
              <td>{index + 1}</td>
              <td>{item.start}-{item.end}</td>
              <td>{item?.fee?.toLocaleString("vi-VN")}</td>
              {vat && <td>{item?.feeItem?.toLocaleString("vi-VN")}</td>}
              {vat && <td>{item?.feeEntrust?.toLocaleString("vi-VN")}</td>}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const renderSubtitle = (name, isDefault, extraClass = "") => (
    <div className={`subtitle d-flex justify-content-between align-items-center ${extraClass}`}>
      <span>{name}</span>
      {isDefault && <span className="badge bg-success">Mặc định</span>}
    </div>
  );

  const renderPanel = (config, title, fees, type) => {
    const linePriceTypes = (level.priceTypes ?? []).filter((item) => item.lineId === config.lineId);
    const hasDefaultPriceType = linePriceTypes.some((item) => item.isDefault);
    return (
      <div className="col-md-6">
        <div className="card mb-2">
          <div className="p-3">
            <p className="fw-bold">{title}</p>
            {renderSubtitle("Bảng giá phổ thông", !hasDefaultPriceType, "bg-01")}
            {renderFeeTable(fees, type, config.vat, null)}
            <div className="sub-price">
              {linePriceTypes.map((priceType) => (
                <div key={priceType.id}>
                  {renderSubtitle(priceType.name, priceType.isDefault)}
                  {renderFeeTable(fees, type, config.vat, priceType.id)}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return CUSTOMER_PRICE_LINES
    .filter((config) => lineIds && lineIds.includes(config.lineId))
    .map((config) => (
      <div className="row" key={config.lineId}>
        {renderPanel(config, config.weightTitle, level[config.weightKey], "kg")}
        {renderPanel(config, config.sizeTitle, level[config.sizeKey], "m3")}
      </div>
    ));
};

const UpdateCustomerCode = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.user.user) || {};
  const isCurrentUserAdmin = currentUser?.isAdmin === true;
  const [historyData, setHistoryData] = useState({});
  const [customer, setCustomer] = useState({});
  const dispatch = useDispatch();
  const [price, setPrice] = useState("");
  const [deletingCustomer, setDeletingCustomer] = useState(false);
  const [customerFeaturePerm, setCustomerFeaturePerm] = useState({
    loaded: false,
    canCreate: false,
    canEdit: false,
  });
  const [newCustomerAccess, setNewCustomerAccess] = useState("allowed");
  const [activeTab, setActiveTab] = useState("tab1");

  useLayoutEffect(() => {
    const gate = isNewCustomerRouteId(id);
    setNewCustomerAccess(gate ? "checking" : "allowed");
  }, [id]);

  useEffect(() => {
    const storedFilters = sessionStorage.getItem('userFilters');
    if (storedFilters) {
      const parsedFilters = JSON.parse(storedFilters);
      dispatch(setFilters(parsedFilters));
      sessionStorage.setItem('userFilters', JSON.stringify(parsedFilters));
    }
  }, [dispatch]);


  useEffect(() => {
    const needCreateGate = isNewCustomerRouteId(id);
    let cancelled = false;

    setCustomerFeaturePerm({ loaded: false, canCreate: false, canEdit: false });

    (async () => {
      const p = await fetchCustomerMenuPermissions(axiosInstance);
      if (cancelled) return;
      setCustomerFeaturePerm({
        loaded: true,
        canCreate: p.canCreate,
        canEdit: p.canEdit,
      });

      if (needCreateGate && !p.canCreate) {
        setNewCustomerAccess("denied");
        return;
      }

      if (needCreateGate) {
        setNewCustomerAccess("allowed");
        fetchCustomerDetails(id);
        return;
      }

      setNewCustomerAccess("allowed");
      if (id != null && id !== "") {
        fetchCustomerDetails(id);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [id]);

  const fetchCustomerDetails = async (customerId) => {
    try {
      const apiId = isNewCustomerRouteId(customerId) ? 0 : customerId;
      var requestApi = `/api/users/getUser?id=${apiId}`;
      const response = await axiosInstance.get(requestApi);

      //const response = await axios.get(`${API_URL}/${customerId}`);
      window.initializeFilterValue({ lines: response.data.data.lines });

      setCustomer(response.data.data);
      setItems(response.data.data.addresses);

      const userLinePrice = response.data.data.userLinePrice;

      setPrice(userLinePrice)

    } catch (error) {
      console.error("Lỗi khi lấy dữ liệu khách hàng:", error);
    }
  };

  const setDetailsItem = async (index, name, e) => {

    var value = e.target.value;
    if (value === 'on') value = e.target.checked;
    const userContacts = [...customer.userContacts];
    var item = userContacts[index];
    if (name === 'contactCode') {
      item.contactName = e.target.dataset.text;
    }

    item[name] = value;
    setCustomer({ ...customer, userContacts: userContacts });
  }
  const setCustomerChange = async (e) => {
    var value = e.target.value;
    var newModel = { ...customer, levelName: value }
    setCustomer(newModel);

    var thTag = e.target.closest('.th');
    if (thTag) {
      var selecteTag = thTag.querySelector('.item_selected');
      if (selecteTag && selecteTag.innerText === value && value) {
        try {
          var requestApi = `/api/levels/getLevelByName?name=${value}`;
          const response = await axiosInstance.get(requestApi);
          setCustomer({ ...newModel, level: response.data.data });
        } catch (error) {
          console.error(error);
          toast.error(error.message);
        }
      }
    }

  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCustomer((prevCustomer) => ({
      ...prevCustomer,
      [name]: value,
    }));
  };

  const handleInputChangeItem = (index, field, value) => {
    const updatedItems = [...items];
    updatedItems[index][field] = value;
    setItems(updatedItems);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const needCreateGateRoute = isNewCustomerRouteId(id);
    const canSubmitWrite =
      customerFeaturePerm.loaded &&
      (needCreateGateRoute ? customerFeaturePerm.canCreate : customerFeaturePerm.canEdit);
    if (!canSubmitWrite) {
      toast.warning("Bạn không có quyền cập nhật.");
      return;
    }

    const userDto = {
      ...customer,
      addresses: items,
      ...(price ? { userLinePrice: price } : {}), // không stringify nữa
      /** Tạo KH mới từ /quan-li-khach-hang/tao-moi → luôn khách thường, không phải member. */
      ...(needCreateGateRoute ? { isMember: false, isAdmin: false } : {}),
    };

    var formData = general.getFormData('#form_user');
    userDto.lines = formData.lines;

    try {
      // Gửi yêu cầu PUT đến API để cập nhật thông tin
      const response = await axiosInstance.put(`/api/users/update`, userDto);
      if (!response.data.success) {
        general.showFormError('#form_user', response.data);
        return;
      }
      if (response.status === 200) {
        toast.success("Cập nhật thành công!", {
          //onClose: () => window.location.reload(),
          autoClose: 2000
        });
        var id = response.data.data;
        fetchCustomerDetails(id);
        //navigate("/admin"); // Điều hướng về trang danh sách khách hàng sau khi cập nhật thành công
      }
    } catch (error) {
      console.error("Lỗi khi cập nhật thông tin khách hàng:", error);
      toast.error("Có lỗi xảy ra khi cập nhật thông tin!");
    }
  };

  const handlePriceChange = (event) => {
    setPrice(event.target.value);
  };

  const [items, setItems] = useState([]);
  const handleAdd = (e) => {
    e.preventDefault();
    setItems([...items, {}]);
  };

  const handleDeleteItem = (index) => {
    const updatedItems = [...items];
    updatedItems.splice(index, 1);
    setItems(updatedItems);
  };

  // Khi thay đổi radio
  const handleDefaultChange = (index) => {
    const updated = items.map((item, i) => ({
      ...item,
      defaultAddress: i === index,
    }));
    setItems(updated);
  };

  const handleBack = () => {
    navigate(general.popUrl());
  };

  const handlePromoteToMember = () => {
    if (!formWritable || !customer?.id || customer.id <= 0) return;
    if (customer.isMember === true) return;
    general.openConfirm(
      async () => {
        try {
          const formData = general.getFormData("#form_user");
          const userDto = {
            ...customer,
            isMember: true,
            addresses: items,
            ...(price ? { userLinePrice: price } : {}),
          };
          userDto.lines = formData.lines;
          const response = await axiosInstance.put(`/api/users/update`, userDto);
          if (!response.data.success) {
            general.showFormError("#form_user", response.data);
            toast.error(response.data.message || "Chuyển thành member thất bại.");
            return;
          }
          toast.success(response.data.message || "Đã chuyển thành thành viên (member).");
          fetchCustomerDetails(customer.id);
        } catch (error) {
          console.error("Lỗi khi chuyển thành member:", error);
          toast.error("Có lỗi xảy ra khi chuyển thành member.");
        }
      },
      "Bạn có chắc muốn chuyển khách hàng này thành <b>thành viên nội bộ (member)</b>? Hệ thống sẽ bật cờ <b>isMember</b> cho tài khoản.",
      "Chuyển thành member",
    );
  };

  const handleResetPassword = () => {
    if (!customer?.id || customer.id <= 0) return;
    general.openConfirm(
      async () => {
        try {
          const response = await axiosInstance.get(`/api/users/resetPassword?id=${customer.id}`);
          if (!response.data.success) {
            toast.error(response.data.message);
            return;
          }
          toast.success(response.data.message || "Đã yêu cầu khách hàng đặt lại mật khẩu.");
        } catch (error) {
          console.error(error);
          toast.error(error.message || "Không thể đặt lại mật khẩu.");
        }
      },
      "Bạn có chắc muốn yêu cầu khách hàng <b>đặt lại mật khẩu</b> để đăng nhập? " +
        "Lần đăng nhập tiếp theo, khách hàng sẽ phải thiết lập mật khẩu mới trước khi sử dụng hệ thống.",
      "Đặt lại mật khẩu",
    );
  };
  const searchRankingHistories = async (e) => {

    var requestApi = `/api/users/searchRankingHistories?userId=${customer.id}`;
    try {
      const response = await axiosInstance.get(requestApi);
      var obj = response.data;

      setHistoryData(obj);
    } catch (err) {
      console.error( err);
    }

  };
  const handleDelete = async () => {
    if (!isCurrentUserAdmin || !customer?.id || customer.id <= 0) return;
    const label =
      String(customer.name || customer.customerCode || customer.email || `#${customer.id}`).trim();
    const confirm = await Swal.fire({
      icon: "warning",
      title: "Xóa khách hàng?",
      html: `Bạn có chắc muốn xóa hẳn khách hàng <b>${label}</b> và <b>toàn bộ dữ liệu liên quan</b> (đơn hàng, hóa đơn, sản phẩm, user con…)? Thao tác không hoàn tác.`,
      showCancelButton: true,
      buttonsStyling: false,
      confirmButtonText: "Xóa",
      cancelButtonText: "Hủy",
      focusCancel: true,
      customClass: {
        confirmButton: "btn btn-danger btn-sm",
        cancelButton: "btn btn-outline-secondary btn-sm",
        actions: "gap-2",
      },
    });
    if (!confirm.isConfirmed) return;

    setDeletingCustomer(true);
    try {
      const { data } = await axiosInstance.put(`/api/users/delete/${customer.id}`);
      if (!data?.success) {
        toast.error(data?.message || "Xóa khách hàng thất bại.");
        return;
      }
      toast.success(data?.message || "Đã xóa khách hàng và dữ liệu liên quan.");
      navigate(CUSTOMER_LIST_PATH);
    } catch (err) {
      const raw = err?.response?.data;
      let msg = err?.message || "Không thể xóa khách hàng.";
      if (typeof raw === "string") msg = raw;
      else if (raw && typeof raw.message === "string") msg = raw.message;
      toast.error(msg);
      console.error("Lỗi xoá:", err);
    } finally {
      setDeletingCustomer(false);
    }
  };

  const isNewCustomerRoute = isNewCustomerRouteId(id);
  const formWritable =
    customerFeaturePerm.loaded &&
    (isNewCustomerRoute ? customerFeaturePerm.canCreate : customerFeaturePerm.canEdit);
  const customerHasEmail = Boolean(String(customer?.email ?? "").trim());
  const emailFieldEditable = formWritable && (isNewCustomerRoute || !customerHasEmail);
  const isChildAccount = Number(customer?.parentId) > 0;
  const isInheritedReadOnly = isChildAccount;
  const canShowChildUsersTab =
    customer.id > 0 &&
    !isChildAccount &&
    customer.isAdmin !== true &&
    customer.isMember !== true;

  const customerTitle = (() => {
    const name = (customer?.name || "").trim();
    const code = (customer?.customerCode || "").trim();
    if (!name && !code) return "Thông tin khách hàng";
    if (!code) return name;
    if (!name) return code;
    return `${name} - ${code}`;
  })();

  if (newCustomerAccess === "denied") {
    return (
      <div>
        <AdLayout>
          <div className="container py-4">
            <div className="alert alert-warning mb-0">Truy cập không được phép.</div>
          </div>
        </AdLayout>
      </div>
    );
  }

  if (newCustomerAccess === "checking") {
    return (
      <div>
        <AdLayout>
          <div className="container py-4 min-vh-25" aria-busy="true" />
        </AdLayout>
      </div>
    );
  }

  return (
    <div>
      <AdLayout>
        <div className="mt-2 container customer-management-page">
          <div className="card shadow-lg1 mb-3">
            <div className="block-header mb-2 position-relative">
              {customer.id > 0 && <span className="record_id">ID: {customer.id}</span>}
              <div className="department-page-header">
                <button
                  type="button"
                  className="department-page-header__back"
                  onClick={() => handleBack()}
                  aria-label="Quay lại"
                  title="Quay lại"
                >
                  <FiArrowLeft size={18} />
                </button>
                <div>{customer.id > 0 ? customerTitle : "Khách hàng mới"}</div>
                {customer.parentId > 0 && (
                  <span className="customer-parent-account-badge">
                    TK chính: {(customer.parentName || "").trim() || "—"}
                  </span>
                )}
              </div>
            </div>

            <ul className="nav nav-tabs">
              <li className="nav-item">
                <div className="tab-mini"></div>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === "tab1" ? "active" : ""}`}
                  onClick={() => setActiveTab("tab1")}
                >
                  Thông tin chung
                </a>
              </li>
              {customer.levelName && (
                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === "tab2" ? "active" : ""}`}
                    onClick={() => setActiveTab("tab2")}
                  >
                    Bảng giá
                  </a>
                </li>
              )}
              {customer.id > 0 && (
                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === "tab3" ? "active" : ""}`}
                    onClick={() => {
                      setActiveTab("tab3");
                      searchRankingHistories();
                    }}
                  >
                    Lịch sử xếp hạng
                  </a>
                </li>
              )}
              {canShowChildUsersTab && (
                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === "tab4" ? "active" : ""}`}
                    onClick={() => setActiveTab("tab4")}
                  >
                    Danh sách user
                  </a>
                </li>
              )}
            </ul>

            <div className="normal-form">
              {activeTab === "tab1" && (
                <div>
                <form id="form_user" className="form_validate" autoComplete="off" onSubmit={handleSubmit}>
                  <div className="container">
                  <div className="row ">
                    <div className="col-md-6 form-item mt-3">
                      <div className="row">
                        <label className="form-label col-form-label col-sm-4 col-4">Email</label>
                        <div className="col-sm-8 col-8">
                          {emailFieldEditable ? (
                            <Form.Control
                              type="email"
                              name="email"
                              value={customer?.email ?? ""}
                              onChange={handleInputChange}
                              placeholder="Email"
                            />
                          ) : (
                            <Form.Control
                              type="text"
                              value={customer?.email ?? ""}
                              disabled
                              readOnly
                              placeholder="Email"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 form-item mt-3">
                      <div className="row">
                        <label className="form-label col-form-label col-sm-4 col-4">Tên đăng nhập</label>
                        <div className="col-sm-8 col-8">
                          <Form.Control
                            type="text"
                            name="username"
                            readOnly={!formWritable}
                            value={customer?.username ?? ""}
                            onChange={handleInputChange}
                            placeholder="Tên đăng nhập"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 form-item">
                      <div className="row">
                        <label className="form-label col-form-label col-sm-4 col-4">Tên khách hàng</label>
                        <div className="col-sm-8 col-8">
                          <Form.Control type="text" name="name" readOnly={!formWritable} value={customer?.name ?? ""} onChange={handleInputChange} placeholder="" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 form-item">
                      <div className="row">
                        <label className="form-label col-form-label col-sm-4 col-4">Mã khách hàng</label>
                        <div className="col-sm-8 col-8">
                          <Form.Control type="text" name="customerCode" readOnly={!formWritable} value={customer?.customerCode ?? ""} onChange={handleInputChange} placeholder="" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 form-item">
                      <div className="row">
                        <label className="form-label col-form-label col-sm-4 col-4">Tên công ty</label>
                        <div className="col-sm-8 col-8">
                          <Form.Control type="text" name="companyName" readOnly={!formWritable} value={customer?.companyName ?? ""} onChange={handleInputChange} placeholder="" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 form-item">
                      <div className="row">
                        <label className="form-label col-form-label col-sm-4 col-4">MST / CCCD</label>
                        <div className="col-sm-8 col-8">
                          <Form.Control type="text" name="taxCode" readOnly={!formWritable} value={customer?.taxCode ?? ""} onChange={handleInputChange} placeholder="" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 form-item">
                      <div className="row">
                        <label className="form-label col-form-label col-sm-4 col-4">Email nhận hóa đơn, chứng từ</label>
                        <div className="col-sm-8 col-8">
                          <Form.Control type="text" name="invoiceEmail" readOnly={!formWritable} value={customer?.invoiceEmail ?? ""} onChange={handleInputChange} placeholder="" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 form-item">
                      <div className="row">
                        <label className="form-label col-form-label col-sm-4 col-4">Điện thoại</label>
                        <div className="col-sm-8 col-8">
                          <Form.Control type="text" name="phoneNumber" readOnly={!formWritable} value={customer?.phoneNumber ?? ""} onChange={handleInputChange} placeholder="" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 form-item">
                      <div className="row">
                        <label className="form-label col-form-label col-sm-2 col-4 col-max174">Địa chỉ văn phòng</label>
                        <div className="col-sm-10 col-8">
                          <Form.Control type="text" name="officeAddress" readOnly={!formWritable} value={customer?.officeAddress ?? ""} onChange={handleInputChange} placeholder="" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 form-item">
                      <div className="row">
                        <label className="form-label col-form-label col-sm-4 col-4">STK công ty</label>
                        <div className="col-sm-8 col-8">
                          <Form.Control type="text" name="companyBankAccount" readOnly={!formWritable} value={customer?.companyBankAccount ?? ""} onChange={handleInputChange} placeholder="" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 form-item">
                      <div className="row">
                        <label className="form-label col-form-label col-sm-4 col-4">STK cá nhân</label>
                        <div className="col-sm-8 col-8">
                          <Form.Control type="text" name="personalBankAccount" readOnly={!formWritable} value={customer?.personalBankAccount ?? ""} onChange={handleInputChange} placeholder="" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 form-item">
                      <div className="row">
                        <label className="form-label col-form-label col-sm-4 col-4">Bảng giá</label>
                        <div className="col-sm-8 col-8">

                          <div className="th filter-editor">
                            <span className="filter-ib" data-source-url={API_URL_All + '/api/levels/searchLevelNames'}>
                              <input type="text" className="form-control" placeholder="Nhập mã khách hàng..." readOnly={!formWritable || isInheritedReadOnly} value={customer?.levelName ?? ""} onChange={(e) => setCustomerChange(e)} />

                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 form-item">
                      <div className="row">
                        <label className="form-label col-form-label col-sm-4 col-4">Lines</label>
                        <div className="col-sm-8 col-8">

                          <div className="th select3">
                            <span className="filter-ib" data-filter="lines" data-source-key="list_lines"><input type="text" placeholder="Tên line" readOnly={!formWritable || isInheritedReadOnly} /></span>
                          </div>
                        </div>
                      </div>

                      <div className="row mt-2">
                        <label className="form-label col-form-label col-sm-4 col-4">Cân tối thiểu (kg)</label>
                        <div className="col-sm-8 col-8">
                          <Form.Control
                            type="number"
                            name="customerMinWeightKg"
                            readOnly={!formWritable || isInheritedReadOnly}
                            min={0}
                            step="0.01"
                            value={customer?.customerMinWeightKg == null ? "" : customer.customerMinWeightKg}
                            onChange={(e) => {
                              const raw = e.target.value;
                              if (raw === "") {
                                setCustomer((prev) => ({ ...prev, customerMinWeightKg: null }));
                                return;
                              }
                              const n = parseFloat(raw);
                              setCustomer((prev) => ({
                                ...prev,
                                customerMinWeightKg: Number.isNaN(n) ? null : n,
                              }));
                            }}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <label className="form-label col-form-label col-sm-4 col-4"></label>
                        <div className="col-sm-12 col-8 pt-2">

                          <div className="group-box p-2" data-text="Bảng giá đối tác">

                            <table className="table table-striped table-hover table-bordered">

                              <thead className="table-primary">
                                <tr>
                                  <th width="50px">STT</th>
                                  <th><span data-note="">Tên line</span></th>
                                  <th><span data-note="">Đối tác mặc định</span></th>
                                  <th><span data-note="">Tên</span></th>
                                  <th><span data-note="">Chi tiết</span></th>
                                </tr>
                              </thead>
                              <tbody>
                                {customer.userContacts && customer.userContacts.map((item, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td className="text-start">{item.lineName}</td>
                                    <td className="text-start">
                                      <div className="th filter-editor">
                                        <span className="filter-ib" data-source-key="code" data-source-text="name" data-source-url={API_URL_All + '/api/contacts/searchContactNames'}><input type="text" data-refer={item.lineId} placeholder="Nhập tên đối tác..." readOnly={!formWritable || isInheritedReadOnly} value={item.contactCode ?? ''} onChange={(e) => setDetailsItem(index, 'contactCode', e)} /></span>
                                      </div>
                                    </td>
                                    <td className="text-start">{item.contactName ?? ''}</td>
                                    <td className="text-start1">
                                      {item.contactId && (
                                        <Link className="small-btn" to={`/contact/${item.contactId}`}>Chi tiết</Link>
                                      )}                                      
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>

                          </div>


                        </div>
                      </div>

                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <label className="form-label col-form-label col-sm-2 col-4 col-max174">Danh sách kho hàng</label>
                        <div className="col-sm-10 col-8 col-normal">
                          {formWritable && !isChildAccount && (
                          <div className="col-md-12 form-item pb-2">
                            <div className="row">
                              <div className="col-sm-10 col-8">
                                <button type="button" className="btn btn-sm btn-primary d-flex justify-content-center align-items-center p-1" onClick={handleAdd}><FaPlus /></button>
                              </div>
                            </div>
                          </div>
                          )}
                          <Card className="p-2 border-1"
                            style={{
                              width: "100%",
                              height: "300px",
                              overflowY: "auto",
                              resize: "vertical"
                            }}
                          >
                            {items.map((addr, index) => (
                              <div key={index} className="item-address">
                                <div className="d-flex flex-column align-items-center mx-3">
                                  <input
                                    type="radio"
                                    className="form-check-input mb-2"
                                    name="defaultAddress"
                                    checked={addr.defaultAddress}
                                    disabled={!formWritable || isInheritedReadOnly}
                                    onChange={() => handleDefaultChange(index)}
                                  />
                                </div>
                                <div className="address-new per100">
                                  <div className="d-flex align-items-center gap-1">
                                    <input type="text" placeholder="Tên KH" readOnly={!formWritable || isInheritedReadOnly} value={addr.name ?? ""} onChange={(e) => handleInputChangeItem(index, "name", e.target.value)} />
                                    <input type="text" placeholder="Số điện thoại" readOnly={!formWritable || isInheritedReadOnly} value={addr.phone ?? ""} onChange={(e) => handleInputChangeItem(index, "phone", e.target.value)} />
                                    {formWritable && !isChildAccount && (
                                    <button
                                      type="button"
                                      className="btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center p-0"
                                      onClick={() => handleDeleteItem(index)}
                                      title="Xoá"
                                    >
                                      <FaTimes />
                                    </button>
                                    )}
                                  </div>
                                  <textarea className="per100 mb-0" placeholder="Địa chỉ" readOnly={!formWritable || isInheritedReadOnly} value={addr.address ?? ""} onChange={(e) => handleInputChangeItem(index, "address", e.target.value)} ></textarea>
                                </div>
                              </div>
                            ))}
                          </Card>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row py-3">
                    <label className="form-label col-form-label col-sm-2 col-4">Thành tích</label>
                    <div className="col-sm-10 col-8">
                      <span><MedalIcon rank={customer?.userRank} /></span>
                    </div>
                  </div>

                  {customer.id > 0 && (
                    <div className="row pb-2">
                      <div className="col-12">
                        <span className="text-muted small">
                          Đăng nhập lần cuối:{" "}
                          {customer.lastLoginAt
                            ? general.formatDateTime3(customer.lastLoginAt)
                            : "Chưa có lần đăng nhập ghi nhận"}
                        </span>
                      </div>
                    </div>
                  )}

                  <div className="text-center position-relative">
                    <div className="absolute-left">
                      {customer.id > 0 && formWritable && customer.isMember !== true && !isChildAccount && (
                        <button type="button" className="btn btn-warning btn-sm mt-2" onClick={handlePromoteToMember}>
                          Chuyển thành member
                        </button>
                      )}
                      {customer.id > 0 && customerFeaturePerm.canEdit && customer.active !== false && (
                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm mt-2 ms-1"
                          onClick={handleResetPassword}
                          title="Yêu cầu khách hàng đặt lại mật khẩu khi đăng nhập lần tiếp theo"
                        >
                          Đặt lại mật khẩu
                        </button>
                      )}
                    </div>
                    {formWritable && (
                      <button type="submit" className="btn btn-sm btn-success m-2 d-inline-flex align-items-center gap-1">
                        <FaCheckCircle />
                        <span>Lưu dữ liệu</span>
                      </button>
                    )}
                    {isCurrentUserAdmin && customer.id > 0 && !isNewCustomerRoute && (
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger m-2 d-inline-flex align-items-center gap-1"
                        onClick={handleDelete}
                        disabled={deletingCustomer}
                        title="Xóa khách hàng và toàn bộ dữ liệu liên quan"
                      >
                        <FaTrash />
                        <span>{deletingCustomer ? "Đang xóa..." : "Xóa"}</span>
                      </button>
                    )}
                  </div>

                  </div>
                </form>
                </div>
              )}

              {activeTab === "tab3" && (
                <div className="container py-3">

                  <div className="row">
                    <div className="col-md-12 mb-3">


                      {historyData.page && historyData.page.content.map((item, index) => (
                        <div className="history-item" data-progress-index={index} key={index}>
                          <div className="progress-name d-flex">
                            <div>Tích lũy:{item.userRank}</div>
                            <div>
                              <span className="medal-x">
                                <MedalIcon rank={item.userRank} /></span>
                            </div>
                          </div>
                          <div className="progress-time"><ClockIcon /> <span>{item.month}: </span><b>{general.formatNumber(item.totalFee)} VNĐ</b> <span>Score: {item.score}</span></div>
                        </div>
                      ))}

                    </div>
                    <div className="col-md-12 mb-3">
                      <small>HC Đồng: {historyData.parent && (general.formatNumber(historyData.parent.bronze))} vnđ </small>
                      <small> - HC Bạc: {historyData.parent && (general.formatNumber(historyData.parent.silver))} vnđ </small>
                      <small> - HC Vàng: {historyData.parent && (general.formatNumber(historyData.parent.gold))} vnđ </small>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "tab2" && (
                <div className="container py-3">
                  {customer.id && customer.level && (
                    <CustomerLevelPriceTables level={customer.level} lineIds={customer.lineIds} />
                  )}

                  <div>
                    <Link className="small-btn" to={`/level/${customer.level?.id}`}>Bảng giá gốc</Link>
                  </div>

                <div className="row d-none">
                  <div className="col-md-6">
                    <Form.Group controlId="ControlTextarea1">
                      <Form.Control
                        as="textarea"
                        rows={20}
                        placeholder="Nhập thông tin bảng giá..."
                        value={price ?? ""}
                        onChange={handlePriceChange}
                        style={{
                          width: "100%",
                          height: "100%",
                          overflowY: "auto",
                          resize: "vertical"
                        }}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <div className="p-2 border"
                      style={{
                        width: "100%",
                        height: "494px",
                        overflowY: "auto",
                        resize: "vertical"
                      }}
                    >
                      {
                        price && (() => {
                          try {
                            const parsed = JSON.parse(price);
                            return Object.entries(parsed).map(([category, units]) => (
                              <section key={category} className="border-bottom p-2">
                                <p className="fw-bold">{category}</p>
                                {Object.entries(units).map(([unit, ranges]) => (
                                  <div key={unit}>
                                    <table className="table table-striped table-hover table-bordered">
                                      <colgroup>
                                        <col style={{ width: '40px' }} />
                                        <col style={{ width: '100px' }} />
                                        <col style={{ width: '100px' }} />
                                      </colgroup>
                                      <thead className="table-primary">
                                        <tr>
                                          <th className="text-uppercase">{unit}</th>
                                          <th>Khoảng</th>
                                          <th>Giá (VNĐ)</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {Object.entries(ranges).map(([range, price]) => (
                                          <tr key={range}>
                                            <td></td>
                                            <td>{range}</td>
                                            <td>{Number(price).toLocaleString()}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                ))}
                              </section>
                            ));
                          } catch (error) {
                            return (
                              <p className="text-danger fw-bold">
                                ❌ JSON bị lỗi cú pháp: {error.message}
                              </p>
                            );
                          }
                        })()
                      }
                    </div>
                  </div>
                </div>
                </div>
              )}

              {activeTab === "tab4" && canShowChildUsersTab && (
                <CustomerChildUsersPanel parentUserId={customer.id} embedded />
              )}
            </div>
            <div className="p-1"></div>
          </div>
          <input type="hidden" id="list_lines" value="TMĐT,Line Thường,Line XT,Line VAT" />
        </div>
      </AdLayout>
    </div>
  );
};

export default UpdateCustomerCode;
